// provide negative number to get random string of that length

export const getRandomAlphaNumericString = (length = -6): string =>
  Math.random().toString(36).slice(length)
